
class AuthenticationApi {
    public static async getJwtIdToken(): Promise<string> {
        return '';
    }
}

export default AuthenticationApi;
